import { notification } from "antd";

/** Same shape as EasyLife's own notifyUser helper, so behaviour matches exactly. */
export function notifyUser(type = "success", message, title = "Notification", placement = "topRight") {
  if (type === "error") {
    notification.error({ message: title, description: message, placement });
  } else {
    notification.success({ message: title, description: message, placement });
  }
}

export default notifyUser;
